<template>
  <div id="tab-container" class="container-fluid">
    <div class="row pl-2 tab-main-area">
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 1}" @click="toFieldEdit()">
        <h6>１　配点Excelの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 2}" @click="toCorrectImageUpload()">
        <h6>２　模範解答の登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 3}" @click="toPositionEdit()">
        <h6>３　採点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 4}" @click="toScorePositionEdit()">
        <h6>４　得点枠の設定</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 5}" @click="toExplanationPdfUpload()">
        <h6>５　解説PDFの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 6}" @click="toMondaiPdfUpload()">
        <h6>６　問題PDFの登録</h6>
      </div>
      <div class="col-md-auto header-tab-button" v-bind:class="{active: tabNo == 7}" @click="toDaimonUpload()">
        <h6>７　大問Pngの登録</h6>
      </div>
    </div>
  </div>  
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: ["tabNo"],
  methods: {
    toFieldEdit(){
      this.$router.push(`/teacher_site/field_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toCorrectImageUpload(){
      this.$router.push(`/teacher_site/correct_image_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toPositionEdit(){
      this.$router.push(`/teacher_site/position_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toScorePositionEdit(){
      this.$router.push(`/teacher_site/score_position_edit/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toMondaiPdfUpload(){
      this.$router.push(`/teacher_site/question_pdf_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toExplanationPdfUpload(){
      this.$router.push(`/teacher_site/explanation_pdf_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
    toDaimonUpload(){
      this.$router.push(`/teacher_site/daimon_upload/${this.$route.params.base_sheet_id}`).catch(err => {});
    },
  }
})
</script>

<style lang="scss" scoped>
  .tab-main-area {
    padding-left: 0px !important;
  }
  .header-tab-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }
</style>